import { invalidateMinicart } from "~/app/store/bffApi";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { toMoxyDateNullable, type MoxyDateString } from "~/common/types/MoxyDate";

export interface QuotePayload {
  quoteNumber: string;
  items: QuotePayloadItem[];
}

export interface QuotePayloadItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  confirmedQuantity?: number;
  quoteLine?: string;
  selectedDeliveryDate?: Date;
  selectedDeliveryDateIsManual: boolean;
  priceReference?: string;
  isRestrictedPackage: boolean;
  originCountry?: string;
  currencyIso: string;
}

interface QuoteSplitCheckoutItemWsDTO extends Omit<QuotePayloadItem, "selectedDeliveryDate"> {
  selectedDeliveryDate: MoxyDateString | null;
}

interface QuoteSplitCheckoutRequestWsDTO extends Omit<QuotePayload, "items"> {
  items: QuoteSplitCheckoutItemWsDTO[];
}

export interface QuoteSplitCheckoutListRequestDTO {
  items: QuoteSplitCheckoutRequestWsDTO[];
}

export function toQuoteSplitCheckoutListRequestDTO(payload: QuotePayload[]): QuoteSplitCheckoutListRequestDTO {
  return {
    items: payload.map((quote) => ({
      ...quote,
      items: quote.items.map((item) => ({
        ...item,
        selectedDeliveryDate: toMoxyDateNullable(item.selectedDeliveryDate),
      })),
    })),
  };
}

export async function sendData(payload: QuotePayload[], override: boolean): Promise<Response> {
  const url = `${occUrl("/quote/split/checkout")}?override=${override}`;
  const request = toQuoteSplitCheckoutListRequestDTO(payload);

  const res = await occFetch(url, {
    body: JSON.stringify(request),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  invalidateMinicart();
  return res;
}
